import {
  FaqCoordinatorsList,
  FaqCoordinatorsShow
} from 'pages/communication/faq_coordinators';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'faq_coordinators',
  label: 'Suporte coordenação',
  list: FaqCoordinatorsList,
  show: FaqCoordinatorsShow,
  actions: ['list', 'show', 'close'],
  parentName: 'communication'
};

export default generateResources(resource);
